import { map, get } from 'lodash';
import { connect } from 'react-redux';

import TopNavigationDesktop from 'components/TopNavigationDesktop';
import { CAMPAIGN_NAMES, RERUN_LABEL } from 'constants/personalizations';
import * as actions from 'state/actions';
import CartSelector from 'state/selectors/cart';
import PersonalizationsSelector from 'state/selectors/personalizations';
import TopNavigationSelector from 'state/selectors/top-navigation';
import Settings from 'utils/Settings';

const mapStateToProps = (state, ownProps) => {
  const nodeTree = TopNavigationSelector.getCurrentTopNavigationTree(state);

  let l1NavigationOptions = map(get(nodeTree, 'subNavigations'), l1Option => l1Option);

  const l1ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 1);

  const { itemCount } = CartSelector.getCart(state);

  const isCartOpen = CartSelector.getIsCartOpen(state);

  const showSearch = Settings.searchIconEnabled;

  const onSearchSubmit = value => {
    window.location.href = `/pages/search?query=${value}`;
  };

  // Rerun Renaming Experiment
  const navigationRerunRenamingExperimentVariation =
    PersonalizationsSelector.getCampaignVariationData(
      state,
      CAMPAIGN_NAMES.NAVIGATION_RERUN_RENAMING
    );
  const isNavigationRerunRenamingExperimentLoading =
    PersonalizationsSelector.getIsExperimentLoading(
      state,
      CAMPAIGN_NAMES.NAVIGATION_RERUN_RENAMING
    );
  const navigationRerunRenamingExperimentAnalyticsData = {
    dyDecisionId: navigationRerunRenamingExperimentVariation?.decisionId,
    dyVariationId: navigationRerunRenamingExperimentVariation?.analyticsMetadata?.variationId,
  };

  if (
    navigationRerunRenamingExperimentVariation?.payload?.data?.label &&
    l1NavigationOptions.length
  ) {
    l1NavigationOptions.forEach(option => {
      if (option.label.toLowerCase() === RERUN_LABEL) {
        option.label = navigationRerunRenamingExperimentVariation.payload.data.label;
      }
    });
  }

  return {
    l1NavigationOptions,
    l1ActiveNode,
    cartItemCount: itemCount,
    isCartOpen,
    isNavigationRerunRenamingExperimentLoading,
    showSearch,
    onSearchSubmit,
    navigationRerunRenamingExperimentAnalyticsData,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  openCart: () => dispatch(actions.openCart({ origination: 'topNavigationCartIcon' })),
  setCurrentTopNavigationNode: id => dispatch(actions.setCurrentTopNavigationNode(id)),
  closeTopNavigation: () => dispatch(actions.closeTopNavigation()),
  trackNavigation: url => {
    dispatch(actions.trackTopNavigationNavigation(url));
    // Because this function will be attached to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
  trackNavigationRerunRenamingExperimentEngagement: (dyDecisionId, dyVariationId) => {
    dispatch(
      actions.trackEngagementClick({
        dyDecisionId,
        dyVariationId,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigationDesktop);
